export function rectToObject(bounds) {
  return {
    top: bounds.top,
    left: bounds.left,
    right: bounds.right,
    bottom: bounds.bottom,
    width: bounds.width,
    height: bounds.height
  };
}